import type { Size } from '../types'

export function IaIcon({ className, size }: { className?: string; size: Size }) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6159 5.37339L9.79135 18.656C9.66326 19.0087 9.32819 19.2434 8.95302 19.2434H8.8134C8.18861 19.2434 7.75744 18.6177 7.97998 18.0338L13.1155 4.56118C13.24 4.23463 13.5436 4.00916 13.893 4.00225C14.1533 3.9971 14.4471 3.99935 14.6473 4.02506C15.0863 4.0814 14.6159 5.37339 14.6159 5.37339ZM19.4631 19.2434C19.0882 19.2434 18.7533 19.0089 18.625 18.6566L13.7902 5.37339C13.7902 5.37339 13.2362 4.08143 13.7589 4.02506C13.9882 4.00032 14.2718 3.99729 14.518 4.00168C14.8649 4.00787 15.1656 4.23231 15.2895 4.55636L20.445 18.0328C20.6684 18.6168 20.2372 19.2434 19.612 19.2434H19.4631ZM17.7516 13.6097C18.2076 13.6097 18.5773 13.9794 18.5773 14.4354C18.5773 14.8915 18.2076 15.2611 17.7516 15.2611H10.8531C10.3971 15.2611 10.0274 14.8915 10.0274 14.4354C10.0274 13.9794 10.3971 13.6097 10.8531 13.6097H17.7516Z"
        fill="currentColor"
      />
      <path
        d="M5.12535 4.02506C5.61795 4.02506 6.01727 4.42439 6.01727 4.91698V18.3515C6.01727 18.8441 5.61795 19.2434 5.12535 19.2434H4.89192C4.39933 19.2434 4 18.8441 4 18.3515V4.91698C4 4.42439 4.39933 4.02506 4.89192 4.02506H5.12535Z"
        fill="currentColor"
      />
    </svg>
  )
}
